import styled, {keyframes} from "styled-components";
import {Modal} from "@consta/uikit/Modal";
import {Button} from "@consta/uikit/Button";

// Анимация для загрузчика
export const pulse = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
`;

export const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

// Стилизованная модалка
export const StyledModal = styled(Modal)`
    z-index: 9999 !important;

    .Modal-Overlay {
        z-index: 9998 !important;
        backdrop-filter: blur(4px);
    }

    .Modal-Window {
        z-index: 9999 !important;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    }
`;

// Контейнер модального окна
export const DiagramModalContainer = styled.div`
    padding: 32px;
    background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
    min-width: 900px;
    min-height: 600px;
    position: relative;
    animation: ${fadeIn} 0.3s ease-out;
`;

// Заголовок
export const DiagramHeader = styled.div`
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const DiagramTitle = styled.h2`
    margin: 0;
    font-size: 26px;
    font-weight: 600;
    color: #1a202c;
    display: flex;
    align-items: center;
    gap: 12px;

    &:before {
        content: '📊';
        font-size: 32px;
    }
`;

export const DiagramSubtitle = styled.p`
    margin: 8px 0 0 40px;
    font-size: 15px;
    color: #718096;
    font-weight: 500;
`;

// Контейнер для диаграммы
export const DiagramContent = styled.div`
    background: white;
    border-radius: 12px;
    padding: 24px;
    min-height: 450px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #e2e8f0;
    position: relative;
    overflow: hidden;
`;

// Загрузчик
export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 450px;
    gap: 20px;
`;

export const LoaderText = styled.p`
    font-size: 16px;
    color: #4a5568;
    font-weight: 500;
    animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const LoaderIcon = styled.div`
    font-size: 48px;
    animation: ${pulse} 1.5s ease-in-out infinite;
`;

// Сообщение об отсутствии данных
export const NoDataMessage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 450px;
    gap: 16px;
    color: #718096;

    &:before {
        content: '📭';
        font-size: 64px;
        opacity: 0.5;
    }
`;

export const NoDataText = styled.p`
    font-size: 18px;
    font-weight: 500;
    margin: 0;
`;

// Обертка для диаграммы
export const ChartWrapper = styled.div`
    width: 100%;
    min-height: 450px;
    animation: ${fadeIn} 0.5s ease-out;
`;

// Футер с кнопками
export const DiagramFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e2e8f0;
    gap: 12px;
`;

export const StyledButton = styled(Button)`
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
`;

// Бейдж с информацией
export const InfoBadge = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    font-size: 13px;
    color: #0050b3;
    font-weight: 500;

    &:before {
        content: 'ℹ️';
        font-size: 14px;
    }
`;